import { MagnifingglassIcon } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';

/**
 * 검색 결과가 없을 때 표시하는 빈 상태 컴포넌트
 */
export const SearchEmpty = ({
  promptQuery
}: {
  promptQuery: string;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <div className="flex size-full flex-col items-center justify-center gap-lg" data-sentry-component="SearchEmpty" data-sentry-source-file="SearchEmpty.tsx">
      <MagnifingglassIcon width={70} height={70} fill={'#1C1B1F12'} data-sentry-element="MagnifingglassIcon" data-sentry-source-file="SearchEmpty.tsx" />
      <div>
        <h6 className="text-center text-heading-md-bold text-default">
          {`"${promptQuery}"`}
        </h6>
        <p className="text-center text-heading-sm-bold text-alternative">
          {t('build:build.standard.search.empty')}
        </p>
      </div>
    </div>;
};